













































































































































































import Vue from 'vue';
import NewsBox from './NewsBox.vue';
import ImageBox from './ImageBox.vue';
import CouponBox from './CouponBox.vue';
import EmojiBox from 'common/components/ui/Emoji/index.vue';
import LinkInsertBox from 'common/components/ui/LinkInsertBox/index.vue';
import MiniProgramBox from 'common/components/ui/MiniProgramBox.vue';
import RichTextBox from 'common/components/ui/RichTextBox/index.vue';
import News from '@/mass/models/News';
import Image from '@/mass/models/Image';
import { Emoji } from '@/common/components/ui/Emoji/emojis';
import EditDiv from '@/rule/components/settings/create/EditDiv.vue';
import SetProp from '@/rule/components/settings/create/SetProp.vue';
import { MustValueProps, ExcludeProps } from '@/rule/models/FieldType';
import massVuex from '../../vuex/common';
import {pasteHtmlAtCaret, pasteTextAtCaret} from '@/common/utils/Caret'


function dripProp(name: string): string  {
  return `<drip-prop contenteditable="false">#${name}</drip-prop>`
}

const couponText: string | null = null;
export interface InitData {
  contentType?: string;
  body?: any;
}

export default Vue.extend({
  mixins: [massVuex],
  components: {
    NewsBox,
    ImageBox,
    CouponBox,
    EmojiBox,
    LinkInsertBox,
    RichTextBox,
    EditDiv,
    SetProp,
    MiniProgramBox,
  },
  props: {
    needCoupon: {
      type: Boolean,
      default: true,
    },
    mode: {
      type: String,
      default: 'typical',
    },
    initText: {
      type: String,
      default: '',
    },
    initData: {
      type: Object,
    },
    isMulti: {
      type: Boolean,
      default: true,
    },
    isMass: {
      type: Boolean,
      default: false,
    },
    showAddProp: {
      type: Boolean,
      default: false,
    },
    showAddMini: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    initNews(): any {
      return ((this.news as any).parentNews || this.initData.body.news);
    },
    initCard(): any {
      const coupon = this.coupon as any;
      const isCouponValid = coupon && coupon.baseInfo && coupon.cardId;
      const init = this.initData && this.initData.body && this.initData.body.card;
      return isCouponValid ? coupon : init;
    },
    optionProps(): any[] {
      return this.props.filter((r: any) => !this.MustValueProps.find((m: any) => m.fieldName === r.fieldName) && !this.ExcludeProps.find((m: any) => m.fieldName === r.fieldName));
    },
    tranProps(): any[] {
      const temp = JSON.parse(JSON.stringify(this.props));
      return temp.map((p: any) => {
        p.propName = dripProp(p.propName)
        return p;
      });
    },
  },
  data() {
    return {
      showNewsBox: false,
      showImageBox: false,
      showCouponBox: false,
      showRemarkBox: false,
      value: null,
      textType: 'TEXT',
      newsType: 'NEWS',
      couponType: 'COUPON',
      contentType: 'TEXT',
      imageType: 'IMAGE',
      scene: 'notActivity',
      news: {},
      image: {},
      coupon: {},
      couponText,
      showRichTextBox: false,
      showEmojiBox: false,
      showLinkInsertBox: false,
      showAddPropBox: false,
      showInsertMiniBox: false,
      content: '',
      currentIndex: 0,
      RichTextTitle: '优惠券文案',
      prop: null,
      visable: false,
      MustValueProps,
      ExcludeProps,
      propConfigs: null,
      disabled: false,
    };
  },
  methods: {
    restoreCursor() {
      (this.$refs['editDiv'] as any).restoreSelection()
    },

    addMiniLink(data: any) {
      const $el = this.$el.querySelector('#contentInfo') as HTMLElement;
      const linkHtml = `<a href="crm.drip.im" data-miniprogram-appid="${data.appid}" data-miniprogram-path="${data.minipath}" >${data.linkText}</a>`
      const tmpStr = this.content;
      if (this.showAddProp) {
        this.restoreCursor()
        pasteHtmlAtCaret(linkHtml)
        this.content = $el.innerHTML
      } else {
        const cursorPos = this.getCursortPosition($el);
        this.content = tmpStr.substring(0, cursorPos) + linkHtml + tmpStr.substring(cursorPos, tmpStr.length);
        this.$nextTick(() => {
          ($el! as HTMLInputElement).selectionStart = cursorPos + linkHtml.length;
        });
      }
      this.showInsertMiniBox = false
    },
    switchTool(curr: string): void {
      const keys = ['showEmojiBox', 'showLinkInsertBox', 'showAddPropBox', 'showInsertMiniBox']
      const _this = (this as any)
      keys.filter(k => k !== curr).forEach(k => {
        this.$set(this, k, false)
      })
      const value = !_this[curr]
      Vue.set(this, curr, value ? true : false)
      this.disabled = true
    },
    checkProp(name: string) {
      const fieldName = name;
      const prop = this.props.find((r: any) => r.fieldName === fieldName);
      if (this.content && prop && this.content.indexOf(dripProp(prop.propName)) > -1) {
        this.$Message.warning('同一字段只能设置一次');
        return;
      }
      if (this.MustValueProps.find((r: any) => r.fieldName === fieldName)) {
        const propText = dripProp(prop.propName)
        if (this.content && this.content.endsWith('<br></div>')) {
          this.content = this.content.substring(0, this.content.length - 10) + propText + '</div>';
        } else if (this.content && this.content.endsWith('</div>')) {
          this.content = this.content.substring(0, this.content.length - 6) + propText + '</div>';
        } else {
          this.content = this.content + propText;
        }
        if (!this.propConfigs) {
          this.propConfigs = [];
        }
        this.propConfigs.push({MustProp: {fieldName: fieldName}});
        this.$emit('updatePropConfigs', this.propConfigs);
      } else if (fieldName === 'custom.current') {
        if (this.content && this.content.indexOf(dripProp('系统时间')) > -1) {
          this.$Message.warning('同一字段只能设置一次');
        } else {
          const propText = dripProp('系统时间')
          if (this.content && this.content.endsWith('<br></div>')) {
            this.content = this.content.substring(0, this.content.length - 10) + propText + '</div>';
          } else if (this.content && this.content.endsWith('</div>')) {
            this.content = this.content.substring(0, this.content.length - 6) + propText + '</div>';
          } else {
            this.content = this.content + propText;
          }
          if (!this.propConfigs) {
            this.propConfigs = [];
          }
          this.propConfigs.push({ExtendProp: {fieldName: fieldName}});
          this.$emit('updatePropConfigs', this.propConfigs);
        }
      } else {
        this.prop = prop;
        this.visable = true;
      }
    },
    setProp(data: any) {
      const propText = dripProp(data.prop.propName)
      if (this.content && this.content.endsWith('<br></div>')) {
        this.content = this.content.substring(0, this.content.length - 10) + propText + '</div>';
      } else if (this.content && this.content.endsWith('</div>')) {
        this.content = this.content.substring(0, this.content.length - 6) + propText + '</div>';
      } else {
        this.content = this.content + propText;
      }
      if (!this.propConfigs) {
        this.propConfigs = [];
      }
      if (data.prop.builtIn) {
        if (this.propConfigs.find((r: any) => r && r.OptionProp && r.OptionProp.fieldName === data.prop.fieldName)) {
          const index = this.propConfigs.findIndex((r: any) => r.OptionProp && r.OptionProp.fieldName === data.prop.fieldName);
          this.propConfigs[index] = {OptionProp: {fieldName: data.prop.fieldName, defaultValue: data.defaultValue}};
        } else {
          this.propConfigs.push({OptionProp: {fieldName: data.prop.fieldName, defaultValue: data.defaultValue}});
        }
      } else {
        if (this.propConfigs.find((r: any) => r && r.OptionProp && r.OptionProp.fieldName === 'privateProps.' + data.prop.fieldName)) {
          const index = this.propConfigs.findIndex((r: any) => r.OptionProp && r.OptionProp.fieldName === data.prop.fieldName);
          this.propConfigs[index] = {OptionProp: {fieldName: 'privateProps.' + data.prop.fieldName, defaultValue: data.defaultValue}};
        } else {
          this.propConfigs.push({OptionProp: {fieldName: 'privateProps.' + data.prop.fieldName, defaultValue: data.defaultValue}});
        }
      }
      this.$emit('updatePropConfigs', this.propConfigs);
      this.visable = false;
    },
    addProp() {
      this.visable = false;
    },
    updateContent(val: string) {
      // console.log(val);
    },
    showBox(type: string) {
      switch (type) {
        case this.textType:
          this.showNewsBox = false;
          this.showImageBox = false;
          this.showCouponBox = false;
          this.showLinkInsertBox = false;
          this.showInsertMiniBox = false
          this.contentType = this.textType;
          this.$emit('selectText', this.content);
          break;
        case this.newsType:
          this.showNewsBox = true;
          this.showImageBox = false;
          this.showCouponBox = false;
          this.showLinkInsertBox = false;
          break;
        case this.couponType:
          this.showNewsBox = false;
          this.showImageBox = false;
          this.showCouponBox = true;
          this.showLinkInsertBox = false;
          this.showInsertMiniBox = false
          break;
        case this.imageType:
          this.showNewsBox = false;
          this.showImageBox = true;
          this.showCouponBox = false;
          this.showLinkInsertBox = false;
          this.showInsertMiniBox = false
          break;
        default: break;
      }
    },
    setCurrentIndex(index: number) {
      this.currentIndex = index;
    },
    confirmSelectNews(item: News) {
      this.showNewsBox = false;
      this.news = item;
      this.contentType = this.newsType;
      this.$emit('selectNews', item);
    },
    confirmSelectImage(item: Image) {
      this.image = item;
      this.contentType = this.imageType;
      this.showImageBox = false;
      this.$emit('selectImage', item);
    },
    confirmSelectCoupon(item: any) {
      this.coupon = item;
      this.contentType = this.couponType;
      this.showCouponBox = false;
      if (!item.cardId) {
        this.couponText = item.baseInfo.title + '<a href="' + this.getCouponHref(item) + '">点击领取</a>';
        this.$emit('updateCouponText', this.couponText);
      } else {
        this.$emit('selectCoupon', item);
      }
    },
    updateCouponText(item: string) {
      this.$emit('updateCouponText', item);
      this.couponText = item;
      this.showRichTextBox = false;
    },
    getCouponHref(coupon: any) {
      return `https://${this.account.domain}.weixin.drip.im/coupon/coupon-fetch/${coupon.id}?special=${this.account.domain}`;
    },
    addLink(val: any) {
      const $el = this.$el.querySelector('#contentInfo');
      let linkHtml
      if(this.showAddProp) {
        linkHtml = `<a href="${val.link}">${val.text}</a>`
      } else {
        linkHtml = `[${val.text}](${val.link})`
      }
      if (this.showAddProp) {
        this.restoreCursor()
        pasteHtmlAtCaret(linkHtml)
        this.content = $el.innerHTML
      } else {
        const tmpStr = this.content;
        const cursorPos = this.getCursortPosition($el);
        this.content = tmpStr.substring(0, cursorPos) + linkHtml + tmpStr.substring(cursorPos, tmpStr.length);
        this.$nextTick(() => {
          ($el! as HTMLInputElement).selectionStart = cursorPos + linkHtml.length;
        });
      }
      this.showLinkInsertBox = false;
    },
    insertEmoji(emoji: Emoji) {
      const name = '[' + emoji.name + ']';
      const $el = this.$el.querySelector('#contentInfo');
      if (this.showAddProp) {
        this.restoreCursor()
        pasteTextAtCaret(emoji.char)
        this.content = $el.innerHTML
      } else {
        const tmpStr = this.content;
        const cursorPos = this.getCursortPosition($el);
        this.content = tmpStr.substring(0, cursorPos) + name + tmpStr.substring(cursorPos, tmpStr.length);
        this.$nextTick(() => {
          ($el! as HTMLInputElement).selectionStart = cursorPos + name.length;
        });
      }
      this.showEmojiBox = false;
    },
    getCursortPosition($el: any) {
      let cursorPos = 0;
      if ((document as any).selection) {
        $el.focus();
        const sel: any = (document as any).selection.addRange();
        sel.moveStart('character', -$el.value.length);
        cursorPos = sel.text.length;
      } else if ($el.selectionStart >= 0) {
        cursorPos = $el.selectionStart;
      }
      return cursorPos;
    },
    hideNewsBox() {
      this.$nextTick(() => {
        this.showNewsBox = false;
      });
    },
  },
  watch: {
    content(val) {
      this.$emit('selectText', val, this.content);
    },
    initData(val) {
      if(val) {
        this.contentType = val.contentType || 'TEXT';
        if(val.contentType === 'TEXT') {
          this.content = val.body.text;
          this.propConfigs = val.body.propConfigs;
          this.$emit('selectText', this.content);
          this.$emit('updatePropConfigs', this.propConfigs);
        }
      }
    },
  },
  mounted() {
    this.content = this.initText;
  },
});
